import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-dev-portal-brand))",
      "fill-rule": "evenodd",
      d: "M12 2.4h6.732L21.6 5.676v13.056L18.324 21.6H5.268L2.4 18.324V5.268L5.676 2.4zm4.272 9.6a4.272 4.272 0 1 1-8.532 0 4.272 4.272 0 0 1 8.52 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }